import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';
import { RegisterGoogleTag } from 'src/app/core/helpers/register-google-tag/register-google-tag';
import { FormResponseService } from '../../core/services/form-response/form-response.service';
import { RoutingPath } from './../../configs/routing-path';

@Component({
	selector: 'app-form-response',
	templateUrl: './form-response.component.html',
	styleUrls: ['./form-response.component.scss']
})
export class FormResponseComponent implements OnInit {

	@Input() title: string;
	@Input() type: string = '';
	@Input() status: boolean = false;
	@Input() icon: string = 'cancel';
	@Input() radicado: string;
	@Input() data: any = {
		info: {
			radicado: '',
		},
		response: []
	};
  @ViewChild("btnconsult", {static: true}) btnconsult: ElementRef;


	prePage = '';
	home = '';
	bodyRegisterGoogle:any;
	descResult='';

	constructor(private _respServices: FormResponseService) { }

	ngOnInit() {
		this.data = this._respServices.getDataInfo();		
		this.radicado = this._respServices.getRadicado();
		this.title = this._respServices.getTitle();
		this.status = this._respServices.getStatus();

		if (this.status) {
			this.type = 'Exitosamente';
			this.icon = 'done';
			this.data.response[this.data.response.length] = {code:'',description:''}
			this.data.response[this.data.response.length] = {code:'',description:'Recibiras al correo electrónico registrado el resultado de la consulta en donde podrás descargar los archivos solicitados, de igual manera a través del Home en la zona Consulta masiva podrás obtener tu consulta una vez se haya finalizado el proceso'}
		}

		this.data.response.forEach(element => {
			this.descResult += element.description;
		});
		//`Tu solicitud de {{title}} ha sido radicada {{ type }}.`
		this.bodyRegisterGoogle = {category:'Envío de solicitud consulta masiva',
								   action:'Estado',
								   label:  'Tu solicitud de '+this.title+' ha sido radicada '+this.type+'.',
								   radicado: this.radicado,
								   event:'ga_event_radicado'};
		RegisterGoogleTag.register(this.bodyRegisterGoogle);

		this.home = RoutingPath.appRouting.components.dashboard.path;
		this.prePage = RoutingPath.appRouting.components.affiliates_process.path + '/' + RoutingPath.appRouting.components.affiliates_process.pages.home.path;

    const input: HTMLInputElement = this.btnconsult.nativeElement as HTMLInputElement;
    input.focus();

	}

}
